import jsonAPI from './json-api'

class Others {
  constructor () {
    this._conf = {
      baseURL: '/api/v1'
    }
  }

  carouselList () {
    return jsonAPI.requestWithAuth('/getBanner', {}, {...this._conf, method: 'post'})
  }

  connectMethod () {
    return jsonAPI.requestWithAuth('/getService', {}, {...this._conf, method: 'post'})
  }

  bannerSpeed () {
    return jsonAPI.requestWithAuth('/getBannerTime', {}, {...this._conf, method: 'post'})
  }
}

export default new Others()
